'use strict';

angular.module('webAgro1App').factory('ParametrosService', function($http) {
  return {
    get: function() {
      var url = SERVER + API_VERSION + 'parametros';
      return $http.get(url);
    },

    save: function(parametro) {
      var url = SERVER + API_VERSION + 'parametros';
      return $http.post(url, {parametro: parametro});
    }
  };
});
